import type { NodeInvitationToken, NodeInvitationTokenKind } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getInvitationToken } from '../../services';

type CreateInvitationTokenVariables = {
  kind: NodeInvitationTokenKind;
  subjectId: string;
  subjectType: 'Event';
};

const defaultErrorHandler = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Unable to generate invitation token.');
};

export const useGetInvitationTokenMutation = () =>
  useMutation<NodeInvitationToken, CreateInvitationTokenVariables>({
    defaultMutateOnError: defaultErrorHandler,
    async mutationFn({ kind, subjectId, subjectType }) {
      const response = await getInvitationToken({
        body: { kind, subjectId, subjectType },
      });

      return response.data;
    },
  });
